var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path4, _rect12, _circle, _circle2, _rect13, _rect14, _rect15, _circle3, _circle4, _rect16, _rect17, _rect18, _circle5, _circle6, _rect19, _rect20, _rect21, _circle7, _circle8, _rect22, _rect23, _rect24, _circle9, _circle10, _rect25, _rect26, _rect27, _circle11, _circle12, _rect28, _rect29, _rect30, _path5, _rect31, _path6, _rect32, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefThumbSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 30 372 314",
    width: 348,
    height: 294,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 386,
    height: 348,
    rx: 0,
    fill: "#EBF4E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 37,
    width: 73,
    height: 292,
    rx: 3,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50 Q26.05 55.95 32 57 Q26.05 58.05 25 64 Q23.95 58.05 18 57 Q23.95 55.95 25 50Z",
    fill: "#2DA44E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 45.5 Q35.525 48.475 38.5 49 Q35.525 49.525 35 52.5 Q34.475 49.525 31.5 49 Q34.475 48.475 35 45.5Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 60 Q37.45 62.55 40 63 Q37.45 63.45 37 66 Q36.55 63.45 34 63 Q36.55 62.55 37 60Z",
    fill: "#45B39D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 81,
    width: 59,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 94,
    width: 59,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 107,
    width: 59,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 120,
    width: 48,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 301,
    width: 63,
    height: 22,
    rx: 2,
    fill: "#E3EFD3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 40,
    width: 170,
    height: 46,
    rx: 3,
    fill: "#FFFFFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 50,
    width: 80,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 62,
    width: 56,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 48,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E3EFD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 54 Q256.9 59.1 262 60 Q256.9 60.9 256 66 Q255.1 60.9 250 60 Q255.1 59.1 256 54Z",
    fill: "#8DC63F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 96,
    width: 82,
    height: 68,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 120,
    r: 11,
    fill: "none",
    stroke: "#45B39D",
    strokeWidth: 5,
    strokeDasharray: "55.29 69.12",
    strokeDashoffset: 0,
    transform: "rotate(-90 128 120)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 120,
    r: 11,
    fill: "none",
    stroke: "#E3EFD3",
    strokeWidth: 5,
    strokeDasharray: "13.82 69.12",
    strokeDashoffset: -55.29,
    transform: "rotate(-90 128 120)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 142,
    width: 50,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 151,
    width: 34,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 96,
    width: 82,
    height: 68,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 120,
    r: 11,
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 5,
    strokeDasharray: "24.19 69.12",
    strokeDashoffset: 0,
    transform: "rotate(-90 216 120)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 120,
    r: 11,
    fill: "none",
    stroke: "#E3EFD3",
    strokeWidth: 5,
    strokeDasharray: "44.92 69.12",
    strokeDashoffset: -24.19,
    transform: "rotate(-90 216 120)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 142,
    width: 50,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 151,
    width: 34,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 172,
    width: 82,
    height: 68,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 196,
    r: 11,
    fill: "none",
    stroke: "#45B39D",
    strokeWidth: 5,
    strokeDasharray: "41.47 69.12",
    strokeDashoffset: 0,
    transform: "rotate(-90 128 196)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 196,
    r: 11,
    fill: "none",
    stroke: "#E3EFD3",
    strokeWidth: 5,
    strokeDasharray: "27.65 69.12",
    strokeDashoffset: -41.47,
    transform: "rotate(-90 128 196)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 218,
    width: 50,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 227,
    width: 34,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 172,
    width: 82,
    height: 68,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 196,
    r: 11,
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 5,
    strokeDasharray: "10.37 69.12",
    strokeDashoffset: 0,
    transform: "rotate(-90 216 196)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 196,
    r: 11,
    fill: "none",
    stroke: "#E3EFD3",
    strokeWidth: 5,
    strokeDasharray: "58.75 69.12",
    strokeDashoffset: -10.37,
    transform: "rotate(-90 216 196)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 218,
    width: 50,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 227,
    width: 34,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 248,
    width: 82,
    height: 68,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 272,
    r: 11,
    fill: "none",
    stroke: "#45B39D",
    strokeWidth: 5,
    strokeDasharray: "62.20 69.12",
    strokeDashoffset: 0,
    transform: "rotate(-90 128 272)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 272,
    r: 11,
    fill: "none",
    stroke: "#E3EFD3",
    strokeWidth: 5,
    strokeDasharray: "6.91 69.12",
    strokeDashoffset: -62.2,
    transform: "rotate(-90 128 272)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 294,
    width: 50,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 303,
    width: 34,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 248,
    width: 82,
    height: 68,
    rx: 3,
    fill: "#FFFFFF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 272,
    r: 11,
    fill: "none",
    stroke: "#8DC63F",
    strokeWidth: 5,
    strokeDasharray: "34.56 69.12",
    strokeDashoffset: 0,
    transform: "rotate(-90 216 272)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 272,
    r: 11,
    fill: "none",
    stroke: "#E3EFD3",
    strokeWidth: 5,
    strokeDasharray: "34.56 69.12",
    strokeDashoffset: -34.56,
    transform: "rotate(-90 216 272)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 294,
    width: 50,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 303,
    width: 34,
    height: 5,
    rx: 1,
    fill: "#E6F0DA"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 38,
    width: 68,
    height: 60,
    rx: 3,
    fill: "#DDEDC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304 44 l-5 3 l5 3Z",
    fill: "#DDEDC8"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 110,
    width: 68,
    height: 74,
    rx: 3,
    fill: "#DDEDC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304 116 l-5 3 l5 3Z",
    fill: "#DDEDC8"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 196,
    width: 68,
    height: 60,
    rx: 3,
    fill: "#DDEDC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304 202 l-5 3 l5 3Z",
    fill: "#DDEDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefThumbSecurity);
export default __webpack_public_path__ + "static/media/brief-thumb-security.93bf5a00c0fa085c62eed1bf2b77a822.svg";
export { ForwardRef as ReactComponent };